import { get } from '@/axios'

import { IBookListResp } from './detail/bookList'
import { INovelDetail } from './novel'

export interface IBannerListResponse {
  list: IBannerListItem[]
}

export interface IBannerListItem {
  app_channel_code: string[]
  created_at: number
  deleted_at: number
  display_ended_at: number
  display_started_at: number
  id: number
  pic_jump_url: { 1: string; 2: string }
  pic_url: string
  sort: number
  updated_at: number
}

export const getBanner = async () => {
  const resp = await get<IBannerListResponse>('/banner/picture')
  return resp
}

export interface IDiscoverThreadListResponse {
  list: IThreadListItem[]
}

export interface IThreadListItem {
  cmty_id: string
  cmty_type: number
  content: string
  created_at: number
  like_num: number
  pic_urls: string[]
  publisher_avatar: string
  publisher_name: string
  resource_data: INovelDetail
  resource_id: string
  resource_type: number
  title: string
  type: number
  user_id: string
}

export const getDiscoverThreadList = async () => {
  const resp = await get<IDiscoverThreadListResponse>('/recoCmty/posts')
  return resp
}

export interface IDiscoverBookListResponse {
  list: IBookListResp[]
}

export const getDiscoverBookList = async () => {
  const resp = await get<IDiscoverBookListResponse>('/recoCmty/storyLists')
  return resp
}

export interface IDiscoverCommentReviewResponse {
  list: IDiscoverCommentReview[]
}

export interface IDiscoverCommentReview {
  /**
   * 评论内容
   */
  content?: string
  /**
   * 评论时间
   */
  created_at?: number
  /**
   * 展示结束时间
   */
  display_ended_at?: number
  /**
   * 展示开始时间
   */
  display_started_at?: number
  id?: number
  /**
   * 评论点赞次数
   */
  like_num?: number
  /**
   * 图片
   */
  pic_urls?: string
  /**
   * 评论ID
   */
  resource_comment_id?: string
  /**
   * 资源ID
   */
  resource_id?: string
  /**
   * 资源内容
   */
  resource_info?: INovelDetail
  /**
   * 资源类型
   */
  resource_type?: number
  /**
   * 排序
   */
  sort?: number
  /**
   * 分表ID
   */
  table_suffix?: string
  /**
   * 用户头像
   */
  user_avatar?: string
  /**
   * 评论用户ID
   */
  user_id?: string
  /**
   * 评论用户名称
   */
  user_nickname?: string
}

export const getDiscoverCommentReview = async () => {
  const resp = await get<IDiscoverCommentReviewResponse>('/comments/recommend')
  return resp
}

export interface IDiscoverGroupListResponse {
  list: IDiscoverGroupItem[]
}

export interface IDiscoverGroupItem {
  created_at: number
  deleted_at: number
  display_ended_at: number
  display_started_at: number
  id: number
  sort: number
  updated_at: number
  group_id: string
  group_info: IGroupInfo | null
  in_group: boolean
}

export interface IGroupInfo {
  id: number
  avatar: string
  name: string
  resource_id: number
  resource_type: number
  num: number
  type: number
  status: number
  announcement: number
  updated_at: number
  is_full: boolean
  created_at: number
  deleted_at: number
}

export const getDiscoverGroup = async () => {
  const resp = await get<IDiscoverGroupListResponse>('/group/groupList')
  return resp
}
